import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#2F2B36",
      contrastText: "#fff",
    },
    secondary: {
      main: "#373737",
      contrastText: "#fff",
    },
    background: {
      default: "#f3f3f3",
    },
  },
  typography: {
    fontFamily: "\"Wix Madefor Text\", Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
